import styled from 'styled-components';
export const Container = styled.div`
   display: flex;
   width: 360px;
   padding: 0.5rem;
   align-items: center;
   flex-direction: column;
   border-radius: 10px;
   box-shadow: 0 1px 1px #ccc;
   background:transparent;
   .line--{
      position: relative;
      display: flex;
      flex-direction: row;
      align-items: center;
      gap: 0.5rem;
   }
   .icon--{
      font-size: 2.5rem;
      color: #919191;
      cursor: pointer;
   }
   .icon--:hover{
      opacity: 0.9;
   }
   .progress--time{
      position: relative;
   }
   .downloading{
      position: absolute;
      visibility: hidden;
      z-index: 9;
      top: -22px;
      right: 0px;
      font-size: 1.5rem;
      color: #9c9c9c;
      cursor: pointer;
   }
   .progress--{
      position: relative;
      display: flex;
      width: 240px;
      height: 16px;
      cursor: pointer;
   }
   .time--{
      position: absolute;
      display: flex;
      top: 13px;
      left: 0px;
      width: 100%;
      padding: 5px 10px 0 10px;
      justify-content: space-between;
      color: #999;
      font-size: 11px;
   }
   .avatar{
      position: relative;
      width: 60px;
      height: 60px;
      border-radius: 50%;
      background-color: #e9ecef; 
      box-shadow: 0 0 3px rgba(0, 0, 0, 0.5);
   }
   .playbackRate{
      display: flex;
      width: 60px;
      height: 60px;
      justify-content: center;
      align-items: center;
      span{
         width: 100%;
         font-size: 1rem;
         font-weight: bolder;
         cursor: pointer;
         padding: 0.3rem;
         color: #ffffff;
         background-color: #dddcdc;
         border-radius:6px; 
      }
      .color--UserSystem{
         background-color: #b3dae9;
      }
   }
   .mic-icon{
      position: absolute;
      bottom: 0px;
      right: -3px;
      font-size: 1.5rem;
      color: #595959;
   }
   &:hover{
      .downloading{
         visibility: visible;
      }
   }
`;
export const LoadSpin = styled.div`
  border: 2px solid #9c9c9c; 
  border-top: 2px solid #0000; 
  border-radius: 50%;
  width: 15px;
  height: 15px;
  animation: spin 1s linear infinite;
  
  @keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }
`;